import {Injectable} from '@angular/core';
import {EntityRepository} from '../../../../projects/entity-manager/src/lib/service/repository/entity-repository';

@Injectable({
    providedIn: 'root'
})
export class UserRepository extends EntityRepository {

}
